import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "-", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_air8_input_number = _resolveComponent("air8-input-number")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.$style.container])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style['number-row']])
    }, [
      _createVNode(_component_air8_input_number, {
        placeholder: _ctx.$t('common.please_input_min'),
        min: _ctx.minInputMinValue,
        precision: _ctx.precision,
        value: _ctx.minValue,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.minValue = $event))
      }, null, 8, ["placeholder", "min", "precision", "value"]),
      _hoisted_1,
      _createVNode(_component_air8_input_number, {
        placeholder: _ctx.$t('common.please_input_max'),
        min: _ctx.maxIputMinValue,
        precision: _ctx.precision,
        value: _ctx.maxValue,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.maxValue = $event))
      }, null, 8, ["placeholder", "min", "precision", "value"])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.footer])
    }, [
      _createVNode(_component_a_button, {
        type: "primary",
        size: "small",
        onClick: _ctx.onQuery
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_SearchOutlined)
        ]),
        default: _withCtx(() => [
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.query')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_a_button, {
        size: "small",
        onClick: _ctx.onReset
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.reset')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ], 2)
  ], 2))
}